<div class="stat_headers">
    <div role="tablist" aria-label="Help sections">
        <div class="support-icons-group-section mb-10">
            <button [ngClass]="{'highlight':currentTab=='videos'}" (click)="setTab1('videos')" aria-label="videos" role="tab">
                <div class="support-icon-section icons-Support">
                    <img id="loader_1" src="/assets/images/video.svg" aria-hidden="true" alt=""> Videos
                </div>
            </button>
        </div>
        <!--
        <div class="support-icons-group-section mb-10">
            <button [ngClass]="{'highlight':currentTab=='search'}" (click)="setTab1('search')" tabindex="-1" aria-hidden="true">
                <div class="support-icon-section icons-Support">
                    <img id="loader_1" src="/assets/images/search.svg" alt="Search">
                    <input title="search" aria-label="search" [(ngModel)]="searchText" type="text" tabindex="0" style="width: 140px;" placeholder="Search">
                </div>
            </button>
        </div>
        -->
        <div class="support-icons-group-section mb-10">
            <button tabindex="0" [ngClass]="{'highlight':currentTab=='guide'}" (click)="setTab1('guide')" aria-label="Guide" role="tab">
                <div class="support-icon-section">
                    <img class="guide" src="/assets/images/guide.svg" aria-hidden="true" alt=""> Guides
                </div>
            </button>
        </div>
    </div>
</div>

<div id="main_content1" style="overflow: auto; width: 100%; height: 450px;">
    <div id="oTab" *ngIf="currentTab=='videos'" class="Help-tab">
        <ul>
            <li *ngIf="role=='Admin' || role=='InstructorAdmin' || role=='Instructor'">
                <a href=" https://content.aba.com/bankexec/files/videos/SimulationSetup.mp4" target="_blank">BankExec Admin Simulation Setup</a>
            </li>
            <li *ngIf="role=='Admin' || role=='InstructorAdmin' || role=='Instructor'">
                <a href="https://content.aba.com/bankexec/files/videos/AddandManageUsers.mp4" target="_blank">BankExec Admin Add and Manage Users</a>
            </li>
            <li *ngIf="role=='Admin' || role=='InstructorAdmin' || role=='Instructor'">
                <a href=" https://content.aba.com/bankexec/files/videos/Reports.mp4" target="_blank">BankExec Admin Reports</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/videos/HowtoPlay.mp4" target="_blank">How to Play</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/videos/ActionPlan.mp4" target="_blank">Action Plan</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/videos/SecurityInputFormDecisions.mp4" target="_blank">Security Input Form Decisions</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/videos/LoanInputFormDecisions.mp4" target="_blank">Loan Input Form Decisions</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/videos/DepositInputFormDecisions.mp4" target="_blank">Deposit Input Form Decisions</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/videos/TreasuryInputFormDecisions.mp4" target="_blank">Treasury Input Form Decisions</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/videos/SubmitForecastorFinalPlan.mp4" target="_blank">Forecast or Submit Final Plan</a>
            </li>
        </ul>
    </div>

    <div id="oTab" *ngIf="currentTab=='search'">
        <help-search-content [helpItem]="helpItem" [searchText]="searchText"></help-search-content>
        <!--
        <div *ngIf="helpItem == 'stats'">
            <table class="help_glossary_table">
                <tr>
                    <td>menu</td>
                    <td>Use the blue menu hamburger icon to access the Action Plan Dashboard, Input Forms, Bank Reports, and Logout.</td>
                </tr>
                <tr>
                    <td>Quarter</td>
                    <td>Indicates the quarter currently displayed in graph. Click arrow to move between quarters and view inputs.</td>
                </tr>
                <tr>
                    <td>Team</td>
                    <td>Your team name is assigned by the instructor and can be changed at any time on the Action Plan Dashboard.</td>
                </tr>
                <tr>
                    <td>Timer</td>
                    <td>Countdown timer indicates time remaining in the current game. The deadline to submit game inputs is determined by your instructor.</td>
                </tr>
                <tr>
                    <td>Community A</td>
                    <td>Displays quarterly results of team inputs for your community. Select the radio buttons to view data results for all teams.</td>
                </tr>
                <tr>
                    <td>Current Quarter Analytics</td>
                    <td>Displays a table format of the graph data values for your community.</td>
                </tr>
            </table>
        </div>
        <div *ngIf="helpItem !='stats' && helpItem !='other'" class="Input_Decisions">
            The Action Plan Dashboard allows you to view and modify the status of your inputs for Security, Loan, Deposit and Treasury. Use the hamburger menu to navigate to the Welcome Screen graph and view the Input form data and results.
            <ul>
                <li>Security Inputs: Security markets-purchase and security sale decisions</li>
                <li>Loans Inputs: Loan decisions</li>
                <li>Deposits Inputs: Deposit and business development (marketing) decisions</li>
                <li>Treasury Inputs: Treasury decisions-purchased funds, capital and other decisions</li>
            </ul>
            <table class="help_glossary_table">
                <tr>
                    <td>Action Plan Dashboard</td>
                    <td>As part of your learning experience, you can create multiple Action Plans and compare the results using a simulated financial Forecast analysis.</td>
                </tr>
                <tr>
                    <td>Current Action Plan</td>
                    <td>Your current Action Plan represents the quantitative input for the four functional areas and allows you to change how your bank works in each of the four functional areas. More than one team member can edit an Action Plan at one time, HOWEVER, there are several rules to follow (see Participant Manual for details).</td>
                </tr>
                <tr>
                    <td>Change Team Name</td>
                    <td>The first time you access the Action Plan Dashboard, you are required to create a Team name. Use the edit icon to modify.</td>
                </tr>
                <tr>
                    <td>Started</td>
                    <td>Clear button indicates inputs have not started. Green button indicates inputs are made. Check mark in the green button means the instructor has viewed the form.</td>
                </tr>
                <tr>
                    <td>Viewed</td>
                    <td>Green button indicates you have viewed the inputs.</td>
                </tr>
                <tr>
                    <td>Modified</td>
                    <td>Green button indicates you have modified the inputs</td>
                </tr>
                <tr>
                    <td>Approved</td>
                    <td>Green button indicates you have approved the inputs. Once you have completed your decisions, move the green button to Approved. This allows other team members to know the status of the page. Results of the quarter will be available as soon as all teams complete their decisions and the Administrator runs the simulation, however, your Instructor/Administrator will determine when the simulation will be re-opened to teams to review results.</td>
                </tr>
                <tr>
                    <td>Print Input Forms</td>
                    <td>View/download all Input form data. Output results are provided as an excel spreadsheet.</td>
                </tr>
                <tr>
                    <td>Forecast Dashboard</td>
                    <td>Run a financial Forecast Simulation to test your current Action Plan. You may create more than one Action Plan to simulate. Please note, the first simulation is free, the rest require overhead charges!. Your overhead charge for the simulation is listed to the right by Overhead Charge under Run/Submit and Financial Forecast simulation and is the running total of the charges for the current quarter.</td>
                </tr>
                <tr>
                    <td>Submit for Competition</td>
                    <td>Select to notify administrator when team is finished entering decisions. Confirm the correct Action Plan name is displayed before you submit. Your final submission is NOT the last Action Plan you were working on! You must submit your Action Plan for competition prior to the deadline. Important: Once data is submitted, it cannot be changed until the Administrator runs the main simulation. You will be locked out of the simulation game once you submit for final competition. Contact your administrator or instructor to ask if your team can go back into the game for corrections and to re-submit.</td>
                </tr>
            </table>
        </div>
        <div *ngIf="helpItem == 'securities'"></div>
        <div *ngIf="helpItem == 'loans'"></div>
        <div *ngIf="helpItem == 'deposits'"></div>
        <div *ngIf="helpItem == 'treasuries'"></div>
        -->
    </div>

    <div id="oTab" *ngIf="currentTab=='guide'" class="Help-tab">
        <ul>
            <li *ngIf="role!='Student'">
                <a href="https://content.aba.com/BankExec/Files/AdministratorQuickStart_Setup.pdf" target="_blank">BankExec Admin Quick Start</a>
            </li>
            <li *ngIf="role!='Student'">
                <a href="https://content.aba.com/BankExec/Files/BX3AdminManual_v1.pdf" target="_blank">BankExec Admin Manual</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/GettingStartedwithBX3_v1.pdf" target="_blank">Getting Started with BankExec</a>
            </li>
            <li>
                <a href="https://content.aba.com/BankExec/Files/BX3ParticipantDecisionManual.pdf" target="_blank">BankExec Participant Decision Manual</a>
            </li>
        </ul>
    </div>
    <!--
    <div class="support-content" *ngIf="helpItem=='other' && currentTab=='search' ">
        <h3 class="heading-level-2 blue-color">Using ABA BANKEXEC Overview</h3>
        <p class="mb-0">ABA BANKEXEC is a unique learning experience designed specifically to provide users real-world banking experience.</p>
        <p class="mb-0">BANKEXEC, an interactive simulation, sets you in the middle of the action</p>
        <h4 class="heading-level-5 blue-color">The BANKEXEC Simulation allows for:</h4>
        <ul class="support-content-list">
            <li>Online, real-time access from classroom or office </li>
            <li>Instant reporting </li>
            <li>Multi-user departmental decision making </li>
            <li>Full graphics and reporting of bank's position and comparison</li>
            <li>scenarios before final decision submissions using a “What-If” </li>
            <li>"As needed" reporting which gathers and presents information </li>
            <li>Online Help Desk — virtually eliminating need for a written user’s</li>
        </ul>
        <div class="read-more-link"><a href="javascript:void(0);">Read More</a></div>
    </div>
    -->
</div>